import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../../components/Dashboard/DashboardPage';
import AiBloggerTab from '../../../components/Dashboard/AiBloggerTab';
import withApollo from '../../../lib/withApollo';

const AiBloggerPage = () => {
  const router = useRouter();

  const { open, status } = router.query;

  return (
    <DashboardPage
      open={open}
      label="aiblogger"
      content={<AiBloggerTab status={status} open={open} />}
      shorttitle="AI Blogger"
    />
  );
};

export default withApollo(AiBloggerPage);
